/**
 * This reducer is used for fetching shipping methods
 */
import {
    GET_SHIPPING_METHODS_REPORT_USAGE,
    GET_OUTSIDE_SHIPPING_METHODS_SUCCESS,
    GET_OUTSIDE_SHIPPING_METHODS_FAILURE,
    GET_INSIDE_SHIPPING_METHODS_SUCCESS,
    GET_INSIDE_SHIPPING_METHODS_FAILURE,
    RESET_REPLENE_SHIPPING_METHOD,
    CLEAR_SHIPPING_ADDRESS,
} from '../action/types';
import { TISSUE_AND_NON_TISSUE_SALES_ORG } from 'src/constants/productConstants';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const initialState = {
    outsideShippingMethods: {
        [TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue]: [],
        [TISSUE_AND_NON_TISSUE_SALES_ORG.tissue]: [],
    },
    insideShippingMethods: {
        [TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue]: [],
        [TISSUE_AND_NON_TISSUE_SALES_ORG.tissue]: [],
    },
    loading: false,
    statusCode: 0,
    statusMessage: '',
};

const reportShippingMethodsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SHIPPING_METHODS_REPORT_USAGE:
            return {
                ...state,
                outsideShippingMethods: {
                    [TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue]: [],
                    [TISSUE_AND_NON_TISSUE_SALES_ORG.tissue]: [],
                },
                insideShippingMethods: {
                    [TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue]: [],
                    [TISSUE_AND_NON_TISSUE_SALES_ORG.tissue]: [],
                },
                loading: true,
            };
        case GET_OUTSIDE_SHIPPING_METHODS_SUCCESS:
            return {
                ...state,
                outsideShippingMethods: {
                    ...state.outsideShippingMethods,
                    [action.payload.salesOrg != 'S030'
                        ? TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue
                        : TISSUE_AND_NON_TISSUE_SALES_ORG.tissue]:
                        action.payload.data,
                },
                showShippingMethods: action.payload.showShippingMethods,
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case GET_OUTSIDE_SHIPPING_METHODS_FAILURE:
            return {
                ...state,
                outsideShippingMethods: [],
                statusCode: action.statusCode,
                showShippingMethods: false,
                statusMessage: action.statusMessage,
                loading: false,
            };

        case GET_INSIDE_SHIPPING_METHODS_SUCCESS:
            return {
                ...state,
                insideShippingMethods: {
                    ...state.insideShippingMethods,
                    [action.payload.salesOrg != 'S030'
                        ? TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue
                        : TISSUE_AND_NON_TISSUE_SALES_ORG.tissue]:
                        action.payload.data,
                },
                showShippingMethods: action.payload.showShippingMethods,
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case GET_INSIDE_SHIPPING_METHODS_FAILURE:
            return {
                ...state,
                insideShippingMethods: [],
                statusCode: action.statusCode,
                showShippingMethods: false,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case RESET_REPLENE_SHIPPING_METHOD:
            return {
                ...state,
                outsideShippingMethods: {
                    ...initialState.outsideShippingMethods,
                },
                insideShippingMethods: {
                    ...initialState.insideShippingMethods,
                },
                showShippingMethods: false,
                loading: initialState.loading,
            };

        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'reportUsageShippingMethodsKey',
        storage: storage,
    },
    reportShippingMethodsReducer
);
